<ng-template [ngIf]="config">
  <div class="form-group" [id]="config.name">
    <ion-label class="form-label">
      {{label | multiLang}}
      <ng-template [ngIf]="config.isRequired">
        <ion-text color="danger">*</ion-text>
      </ng-template>
    </ion-label>
    <!-- <ionic4-star-rating class="m-t-5"
          activeIcon = "ios-star" 
          defaultIcon = "ios-star-outline"
          activeColor = "{{activeColor}}" 
          defaultColor = "#C8C8C8"
          readonly="false"
          rating="{{selectedRating}}"
          maxRating="{{count}}"
          (ratingChanged)="logRatingChange($event)">
        </ionic4-star-rating> -->
  </div>
  <div *ngIf="config.isRequired && control.invalid && (control.dirty || control.touched)" class="m-b-10">
    <ion-text *ngIf="control.hasError('min')" color="danger" class="m-b-5">
      <span class="f-12">{{config.name}} is required</span>
    </ion-text>
  </div>


</ng-template>